'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/yearsAgo.js
// module id = 229
// module chunks = 0